import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { TipoDifferenzaEnum } from "@app/shared/enum/tipo-differenza.enumDTO";
import { AttivitaUnitaDocumentariaVO } from "@app/shared/vo/attivita-unita-documentariaVO";
import { AutoreVO } from "@app/shared/vo/autoreVO";
import { DifferenzaVO } from "@app/shared/vo/differenzaVO";
import { DocumentoVO } from "@app/shared/vo/documentoVO";
import { OrdinamentoVO } from "@app/shared/vo/ordinamentoVO";
import { PaginazioneVO } from "@app/shared/vo/paginazioneVO";
import { StrutturaFascicoloVO } from "@app/shared/vo/struttura-fascicoloVO";
import { UtenteVO } from "@app/shared/vo/utenteVO";
import { ColumnMode } from "@swimlane/ngx-datatable";

@Component({
  selector: "app-storico-documento",
  templateUrl: "./storico-documento.component.html",
})
export class StoricoDocumentoComponent implements OnInit, OnChanges {
  @Input()
  storicoModifiche: AttivitaUnitaDocumentariaVO[];
  @Input()
  allegati: DocumentoVO[];
  @Output() setPage: EventEmitter<any> = new EventEmitter<any>();
  @Output() sortEmit: EventEmitter<any> = new EventEmitter<any>();
  messages = {
    emptyMessage: "Nessuna modifica",
    totalMessage: "totali",
  };
  @Input()
  paginazione: PaginazioneVO;
  ordinamento: OrdinamentoVO;
  @ViewChild("myTable", { static: false }) table: any;
  ColumnMode = ColumnMode;
  expanded: any = {};
  timeout: any;
  list: any[] = [];
  allegatoAggiunto: DocumentoVO;
  allegato: DocumentoVO;

  constructor() { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes.storicoModifiche &&
      changes.storicoModifiche.currentValue
    ) {
      console.log(
        "[StoricoDOcumentoComponent][ngOnChanges] cambio storicoModifiche"
      );
      this.storicoModifiche = JSON.parse(
        JSON.stringify(changes.storicoModifiche.currentValue)
      );

      this.storicoModifiche = [...this.storicoModifiche];
    }
  }

  public onSetPage(pageInfo) {
    console.log("***onsetPage -- START", pageInfo);
    this.setPage.emit(pageInfo.offset);
    console.log("setPage -- END ", this.paginazione);
  }

  public sortOperazioni(event: any) {
    console.log("[sortOperazioni]", event.sorts[0]);
    this.sortEmit.emit(event.sorts[0]);
  }

  onDetailToggle(event) {
    console.log("Detail Toggled", event);
  }

  toggleExpandRow(row) {
    console.log("Toggled Expand Row!", row);
    if (
      row.tipoOperazione !== "CREAZIONE" &&
      row.tipoOperazione !== "BLOCCA_UD" &&
      row.tipoOperazione !== "SBLOCCA_UD" &&
      row.tipoOperazione !== "CHIUDI_UD" &&
      row.tipoOperazione !== "ELIMINA"
    ) {
      if (
        row.tipoOperazione === "AGGIUNGI_ALLEGATO" ||
        row.tipoOperazione === "ELIMINA_ALLEGATO"
      ) {
        this.compattaDifferenze(row.differenze);
      }
      this.table.rowDetail.toggleExpandRow(row);
    }
  }

  cercaFile(differenza: DifferenzaVO): string {
    let indice = differenza.campo.substring(10, 11);
    return this.allegati[indice].nome;
  }

  compattaDifferenze(row: DifferenzaVO[]): DocumentoVO[] {
    let allegato = new DocumentoVO();
    allegato.autore = new AutoreVO();
    allegato.autore.utente = new UtenteVO();
    let allegati = new Array<DocumentoVO>();
    let file = row[0].nomeAllegato;
    for (let i = 0; i < row.length; i++) {
      if (row[i].nomeAllegato !== file) {
        file = row[i].nomeAllegato;

        allegati.push(allegato);
        allegato = new DocumentoVO();
        allegato.autore = new AutoreVO();
        allegato.autore.utente = new UtenteVO();
      }

      if (row[i].campo.includes("/tipologiaDocumento")) {
        if (row[i].tipoDifferenza === TipoDifferenzaEnum.AGGIUNTO) {
          allegato.tipologiaDocumento.nome = row[i].valoreFinale;
        } else {
          allegato.tipologiaDocumento.nome = row[i].valoreIniziale;
        }
      }
      if (
        !row[i].campo.includes("/autore/nome") &&
        row[i].campo.includes("/nome")
      ) {
        if (row[i].tipoDifferenza === TipoDifferenzaEnum.AGGIUNTO) {
          allegato.nome = row[i].valoreFinale;
        } else {
          allegato.nome = row[i].valoreIniziale;
        }
      }

      if (row[i].campo.includes("/tipoSupportoOriginale")) {
        if (row[i].tipoDifferenza === TipoDifferenzaEnum.AGGIUNTO) {
          allegato.tipoSupportoOriginale = row[i].valoreFinale;
        } else {
          allegato.tipoSupportoOriginale = row[i].valoreIniziale;
        }
      }

      if (row[i].campo.includes("/autore/nome")) {
        if (row[i].tipoDifferenza === TipoDifferenzaEnum.AGGIUNTO) {
          allegato.autore.utente.nome = row[i].valoreFinale;
        } else {
          allegato.autore.utente.nome = row[i].valoreIniziale;
        }
      }
      if (row[i].campo.includes("/autore/cognome")) {
        if (row[i].tipoDifferenza === TipoDifferenzaEnum.AGGIUNTO) {
          allegato.autore.utente.cognome = row[i].valoreFinale;
        } else {
          allegato.autore.utente.cognome = row[i].valoreIniziale;
        }
      }
      if (row[i].campo.includes("/autore/cmu")) {
        if (row[i].tipoDifferenza === TipoDifferenzaEnum.AGGIUNTO) {
          allegato.autore.struttura.cmu = row[i].valoreFinale;
        } else {
          allegato.autore.struttura.cmu = row[i].valoreIniziale;
        }
      }
    }
    allegati.push(allegato);

    return allegati;
  }
}
